
/*
 * mkb-framework
 * ============================================================================
 * Module View
 * ============================================================================
 * author: mikabo
 * http://www.mikabo.com
 * ============================================================================
 * Copyright (c) 2015, mikabo
 * All rights reserved.
 * ============================================================================
 */
define('components/aktuelles/views/module.view',['require','exports','module','jquery','underscore','app','jquery.backstretch','mCustomScrollbar','mkb.pegel'],function(require, exports, module) {

	'use strict';

	//-----------------------------------------------------------------------------------------------------
	//Require
	//-----------------------------------------------------------------------------------------------------
	var $ = require('jquery');
	var _ = require('underscore');

	var app = require('app');

	// Third-party tools.
	var JqueryBackstretch = require('jquery.backstretch');
	var mCustomScrollbar = require('mCustomScrollbar');

	var mkbPegel = require('mkb.pegel');


	//-----------------------------------------------------------------------------------------------------
	//Vars
	//-----------------------------------------------------------------------------------------------------
	var moduleName = 'AktuellesModule';
	var initialized = false;

	//-----------------------------------------------------------------------------------------------------
	//Module
	//-----------------------------------------------------------------------------------------------------
	var ModuleView = function() {

		var module = moduleName + ' View';

		var initialize = function() {

			console.log('initialize: ', module);

		};
		var init_backstretch = function() {

			$("body").backstretch( app.images + "main_background.jpg" );
		};

		var buildPegel = function() {

			//var url_mehr_infos = 'http://www.bsh.de/aktdat/wvd/StPauli_pgl.htm';
			var url_mehr_infos = 'http://www.bsh.de/aktdat/wvd/wastabelb.htm';
			var href_mehr_infos = '<a class="info" href="' + url_mehr_infos + '" target="_blank">mehr Infos</a>';
			var cb = function(data) {
				var t = '<h2 class="weiss">Aktueller Wasserstand</h2>' + '<div class="wasserstand">' + data.value + '</div><h3>Messzeit: ' + data.timestamp + '</h3>' + href_mehr_infos;
				$('#pegel').hide().html(t).fadeIn(500);
			};

			var pegel = new MKB.Pegel({
				el              : '#pegel',
				preloader       : app.images + 'preloaders/preloader-white.gif',
				clickEvent      :  false,
				url             : 'http://www.pegelonline.wsv.de/webservices/rest-api/v2/stations/HAMBURG-ST.PAULI.json?includeTimeseries=true&includeCurrentMeasurement=true',
				getWasserstand  : cb
			});

		};

		this.init = function() {

			console.log('init: ', module);
			//init_backstretch();	// sollte erstmal deaktiviert werden
			buildPegel();

			var $window = $( window );
			var $document = $( document );

			var $wrapper_contentarea = $( "#wrapper_contentarea" );
			var $wrapper_sidebar = $( "#wrapper_sidebar" );

			var height_content = $wrapper_contentarea.height();
			var height_sidebar = $wrapper_sidebar.height();

			var mainHeight = height_content;

			if ( height_sidebar > height_content ) {
					mainHeight = height_sidebar;
			}

			var resize = function() {

				var window_height = $window.height();
				var document_height = $document.height();

				if ( window_height > mainHeight ) {
					$wrapper_contentarea.height( window_height );
					$wrapper_sidebar.height( window_height );
				} else {
					$wrapper_contentarea.height( mainHeight );
					$wrapper_sidebar.height( mainHeight );
				}
			};

			$window.resize(function(e) {
				resize();
			});

			resize();

		};

		initialize();

	};

	module.exports = ModuleView;

});